import { ActivitiesContentType, LESSON_ACTIVITIES } from 'global/constants';
import { PStyled } from 'approot/shared/styles/typography.style';
import * as Styled from './activity-sample-banner.style';

type Props = {
  contentType: ActivitiesContentType;
  isPublic: boolean;
};

const ActivitySampleBanner = ({ contentType, isPublic }: Props) => {
  const contentLabel =
    contentType === LESSON_ACTIVITIES ? 'lesson' : 'assessment';

  return (
    <Styled.ActivitySampleBanner>
      {isPublic ? (
        <PStyled marginBottom={0}>
          <strong>This is a sample {contentLabel}.</strong> Responses added here
          will not be saved.
        </PStyled>
      ) : (
        <PStyled marginBottom={0}>
          <strong>This is a draft {contentLabel}.</strong> Responses added in
          present mode will not be saved.
        </PStyled>
      )}
    </Styled.ActivitySampleBanner>
  );
};

export default ActivitySampleBanner;
